import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
    withStyles,
    Button,
    CircularProgress,
    Typography,
    FormGroup,
    FormControlLabel,
    Paper,
    Checkbox,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { BackButton, hasPermission, safeParse } from '../../../../sc-utilities';
import * as deviceCasePreselectionActions from '../../store/deviceCasePreselectionActions';
import History from '../../../../../History';

const styles = (theme) => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    form: {
        width: '95%',
        margin: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: '100%',
        marginTop: '10px',
    },
    text: {
        borderRadius: '1px',
        marginRight: 10,
        color: theme.palette.buttonText.default,
    },
    divider: {
        margin: theme.spacing(1),
    },
    formControl: {
        width: '100%',
    },
    buttons: {
        textAlign: 'right',
        padding: theme.spacing(2),
    },
});
const DeviceCasePreselectionDiagnoseDetailsMotherboard = (props) => {
    const { classes, translations, permissions, activeCustomerID, onUpdateDeviceCasePreselectionDiagnoseCaseParams } =
        props;

    const deviceCasePreselectionDiagnoseCase =
        props.location.state?.redirectOptions?.rowData?.DeviceCasePreselectionDiagnoseCase ?? null;
    const params = safeParse(deviceCasePreselectionDiagnoseCase?.Params);

    const initialValues = {
        cmos_checksum: params?.cmos_checksum ?? true,
        cmos_battery: params.cmos_battery ?? true,
        rtc: params?.rtc ?? true,
        uefi: params?.uefi ?? false,
        dmi: params?.dmi ?? true,
    };

    const hasDiagnoseCaseUpdatePermission = hasPermission(permissions, 'device_case_preselection_update');

    const formSettings = {
        Validation: {
            cmos_checksum: Yup.boolean(),
            cmos_battery: Yup.boolean(),
            rtc: Yup.boolean(),
            uefi: Yup.boolean(),
            dmi: Yup.boolean(),
        },
        FormTitle: translations['update_parameters'] || 'Update parameters',
        ButtonSubmit: hasDiagnoseCaseUpdatePermission
            ? {
                  Title: translations['save'] || 'SAVE',
              }
            : null,
    };
    const handleEdit = async (data) => {
        await onUpdateDeviceCasePreselectionDiagnoseCaseParams({
            Params: {
                cmos_checksum: data.cmos_checksum,
                cmos_battery: data.cmos_battery,
                rtc: data.rtc,
                uefi: data.uefi,
                dmi: data.dmi,
            },
            DiagnoseCaseID: deviceCasePreselectionDiagnoseCase?.DiagnoseCaseID,
            DeviceCasePreselectionID: deviceCasePreselectionDiagnoseCase?.DeviceCasePreselectionID,
            ActiveCustomerID: activeCustomerID,
        });
        History.goBack();
    };
    return (
        <Paper className={classes.root}>
            {BackButton(translations, classes.customTooltip)}
            <Formik
                initialValues={initialValues}
                enableReinitialize
                onSubmit={handleEdit}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {(formikProps) => {
                    const { values, isSubmitting, handleChange, isValid, dirty, handleSubmit } = formikProps;
                    return (
                        <form className={classes.form} onSubmit={handleSubmit}>
                            <>
                                <Typography align="center" variant={'h5'}>
                                    {translations['motherboard'] || 'Motherboard'}
                                </Typography>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color={'primary'}
                                                margin={'dense'}
                                                name={'cmos_checksum'}
                                                checked={values.cmos_checksum}
                                                onChange={handleChange}
                                            />
                                        }
                                        label={`${translations['cmos_checksum'] || 'CMOS checksum'}`}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color={'primary'}
                                                margin={'dense'}
                                                name={'cmos_battery'}
                                                checked={values.cmos_battery}
                                                onChange={handleChange}
                                            />
                                        }
                                        label={`${translations['cmos_battery'] || 'CMOS battery'}`}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color={'primary'}
                                                margin={'dense'}
                                                name={'rtc'}
                                                checked={values.rtc}
                                                onChange={handleChange}
                                            />
                                        }
                                        label={`${translations['rtc'] || 'RTC'}`}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color={'primary'}
                                                margin={'dense'}
                                                name={'uefi'}
                                                checked={values.uefi}
                                                onChange={handleChange}
                                            />
                                        }
                                        label={`${translations['uefi'] || 'UEFI'}`}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color={'primary'}
                                                margin={'dense'}
                                                name={'dmi'}
                                                checked={values.dmi}
                                                onChange={handleChange}
                                            />
                                        }
                                        label={`${translations['dmi'] || 'DMI'}`}
                                    />
                                </FormGroup>
                            </>
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        fullWidth={true}
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                    >
                                        {isSubmitting ? (
                                            <CircularProgress size={24} />
                                        ) : (
                                            formSettings.ButtonSubmit.Title
                                        )}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};
const mapStateToProps = (state) => {
    return {
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
        permissions: state?.core?.login?.permissions || [],
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID ?? null,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        onUpdateDeviceCasePreselectionDiagnoseCaseParams: (params) =>
            dispatch(deviceCasePreselectionActions.editDeviceCasePreselectionDiagnoseCaseParams(params)),
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(DeviceCasePreselectionDiagnoseDetailsMotherboard));
